/* eslint-disable complexity */

$(document).ready(function() {
    var windowWidth = $(window).width();
    var quoteText, quoteTextLength;

    if (!$(window).resized) {
        if (windowWidth > 0 && windowWidth <= 567) {
            quoteText = $('div.image-quote-text').find('blockquote').text();
            quoteText = jQuery.trim(quoteText);
            quoteTextLength = quoteText.length;
            if (quoteTextLength <= 92) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '22px' });
            } else if (quoteTextLength > 92 && quoteTextLength <= 147) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '20px' });
            } else if (quoteTextLength > 147 && quoteTextLength <= 202) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '18px' });
            } else if (quoteTextLength > 202 && quoteTextLength <= 250) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '16px' });
            } else if (quoteTextLength > 202) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '15px' });
            }
        }
        if (windowWidth > 567 && windowWidth <= 767) {
            quoteText = $('div.image-quote-text').find('blockquote').text();
            quoteText = jQuery.trim(quoteText);
            quoteTextLength = quoteText.length;
            if (quoteTextLength <= 92) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '31px' });
            } else if (quoteTextLength > 92 && quoteTextLength <= 147) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '22px' });
            } else if (quoteTextLength > 147 && quoteTextLength <= 202) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '18px' });
            } else if (quoteTextLength > 202 && quoteTextLength <= 250) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '16px' });
            } else if (quoteTextLength > 250) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '15px' });
            }
        }
        if (windowWidth > 767 && windowWidth <= 991) {
            quoteText = $('div.image-quote-text').find('blockquote').text();
            quoteText = jQuery.trim(quoteText);
            quoteTextLength = quoteText.length;
            if (quoteTextLength <= 92) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '36px' });
            } else if (quoteTextLength > 92 && quoteTextLength <= 147) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '25px' });
            } else if (quoteTextLength > 147 && quoteTextLength <= 202) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '22px' });
            } else if (quoteTextLength > 202 && quoteTextLength <= 250) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '18px' });
            } else if (quoteTextLength > 250) {
                $('div.image-quote-text').find('blockquote').css({ fontSize: '15px' });
            }
        }
        if (windowWidth > 991) {
            quoteText = $('div.image-quote-text').find('blockquote').text();
            quoteText = jQuery.trim(quoteText);
            quoteTextLength = quoteText.length;
            if (quoteTextLength > 92 && quoteTextLength <= 147) {
                $('div.image-quote-text')
                    .find('blockquote')
                    .css({ fontSize: '40px', 'line-height': '1.15' });
            } else if (quoteTextLength > 147 && quoteTextLength <= 202) {
                $('div.image-quote-text')
                    .find('blockquote')
                    .css({ fontSize: '35px', 'line-height': '1.15' });
            } else if (quoteTextLength > 202 && quoteTextLength <= 250) {
                $('div.image-quote-text')
                    .find('blockquote')
                    .css({ fontSize: '30px', 'line-height': '1.15' });
            } else if (quoteTextLength > 250) {
                $('div.image-quote-text')
                    .find('blockquote')
                    .css({ fontSize: '20px', 'line-height': '1.15' });
            }
        }
    }
});
